// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608051957/js/" + chunkId + "." + {"44":"2299a1ed","225":"3e99b0f5","481":"f9411fd1","486":"52ab3ff3","770":"a89d175d"}[chunkId] + ".0.6336146660203492.chunk.js";
};